import React, { useRef, useState } from 'react'
import style from './TeamsDetails.module.scss'
import Employee from "../Employee/Employee.jsx";
import { Swiper, SwiperSlide } from 'swiper/react';

export default function TeamsDetails({teamsData}) {
    return (
        <div className='container'>
            <h2 className={style.title}>Наша команда</h2>
           <div className={style.specializationContainer}>
               <div className={style.innerContainer}>
                   <h3 className={style.specialization}>Юристы</h3>
                   <p className={style.subSpecialization}>Level is made up of forward-thinking lawyers who are immersed in the industries they work within.</p>
                   <Swiper
                       slidesPerView={1}
                       spaceBetween={30}
                       className="mySwiperSpecializations"
                       breakpoints={{
                           600: {
                               slidesPerView: "auto",
                               spaceBetween: 80,
                           },
                       }}
                   >
                       {teamsData.map((team, index) => {
                           return (
                               <SwiperSlide key={index}>
                                   <Employee
                                       firstName={team.attributes.firstName}
                                       lastName={team.attributes.lastName}
                                       img={team.attributes.userAvatar.data.attributes}
                                   />
                               </SwiperSlide>
                           )
                       })}
                   </Swiper>
               </div>
               <div className={style.innerContainer}>
                   <h3 className={style.specialization}>Управление</h3>
                   <p className={style.subSpecialization}>Level is made up of forward-thinking lawyers who are immersed in the industries they work within.</p>
                   <div >
                       <Employee />
                   </div>
               </div>
           </div>
        </div>
    )
}
